<template>
  <div>
    <div class="hero order-bg">
      <div class="inner">
        <h1>{{$t('orderManagementSystemPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('orderManagementSystemPage.text2')}}</h5>
      </div>
    </div>

    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title variant">{{$t('orderManagementSystemPage.text3')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid text-left line">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/order-icon1.svg" alt="" /></div>
            <h5>{{$t('orderManagementSystemPage.text4')}}</h5>
            <ul class="col-list">
              <li>{{$t('orderManagementSystemPage.text5')}}</li>
              <li>{{$t('orderManagementSystemPage.text6')}}</li>
              <li>{{$t('orderManagementSystemPage.text7')}}</li>
							<li>{{$t('orderManagementSystemPage.text8')}}</li>
							<li>{{$t('orderManagementSystemPage.text9')}}</li>
            </ul>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/order-icon2.svg" alt="" /></div>
            <h5>{{$t('orderManagementSystemPage.text10')}}</h5>
						<ul class="col-list">
							<li>{{$t('orderManagementSystemPage.text11')}}</li>
							<li>{{$t('orderManagementSystemPage.text12')}}</li>
							<li>{{$t('orderManagementSystemPage.text13')}}</li>
						</ul>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/order-icon3.svg" alt="" /></div>
            <h5>{{$t('orderManagementSystemPage.text14')}}</h5>
						<ul class="col-list">
							<li>{{$t('orderManagementSystemPage.text15')}}</li>
							<li>{{$t('orderManagementSystemPage.text16')}}</li>
						</ul>
          </div>
        </div>
    </div>
    </section>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('orderManagementSystemPage.text17')}}</h2>
        <p>{{$t('orderManagementSystemPage.text18')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'OrderManagementSystemPage',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
